import { Component, Input } from "@angular/core";

@Component({
  selector: "app-table-footer",
  templateUrl: "./table-footer.component.html",
  styleUrls: ["./table-footer.component.scss"],
})
export class TableFooterComponent {
  @Input() lista: any;
  constructor() {}
}
